"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Aside = function Aside(_ref) {
  var schedule = _ref.schedule,
      customTracks = _ref.customTracks;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "time-track__aside"
  }, schedule.map(function (sch) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "time-track__track",
      key: sch.title
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "time-track__track-title"
    }, sch.title));
  }), customTracks.map(function (tr, ind) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)('time-track__track', {
        odd: tr.odd
      }),
      key: "".concat(tr.title, "-").concat(ind)
    }, tr.notitle ? null : /*#__PURE__*/_react.default.createElement("div", {
      className: "time-track__track-title"
    }, tr.title));
  }));
};

var _default = Aside;
exports.default = _default;